import { Stack } from '@mui/material';

import TimerDigitTextField from '../TimerDigitTextField';
import { Colon } from './styles';
import useTimerForm from './vm';

const TimerForm = () => {
  const { formMethods, onSubmit } = useTimerForm();
  const { handleSubmit, control } = formMethods;

  return (
    <Stack direction="row" alignItems="center" gap={2} component="form" noValidate>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <TimerDigitTextField control={control} name="minutes1" onBlur={handleSubmit(onSubmit)} />
        <TimerDigitTextField control={control} name="minutes2" onBlur={handleSubmit(onSubmit)} />
      </Stack>
      <Colon />
      <Stack direction="row" alignItems="center" gap={0.5}>
        <TimerDigitTextField
          control={control}
          name="seconds1"
          upperLimit={5}
          onBlur={handleSubmit(onSubmit)}
        />
        <TimerDigitTextField control={control} name="seconds2" onBlur={handleSubmit(onSubmit)} />
      </Stack>
    </Stack>
  );
};

export default TimerForm;
